import DOMPurify from 'dompurify';

// 공지/FAQ/약관 등 admin이 작성한 콘텐츠를 v-html로 렌더링하는 화면들이 sanitize 없이
// 그대로 렌더링하고 있었음(2026-07-31 보안감사 낮음 등급 항목) — AlertTemp.vue에 적용한 것과
// 동일한 방어를 공용 함수로 뽑아 재사용한다.
export default function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || '');
}
